import { constants, object } from 'common/helpers'
import { getCookieValue } from 'helpers'


export const initialState = {
  isFetching: false,
  shipmentInterval: '',
  price: 0,
  tax: 0,
  discount: 0,
  shipping: 0,
  plan: 0,
  error: '',
  showModal: false,
  modalText: '',
  userBalance: 0,
  useBalance: true,
  orderNo: 0,
  backLink: null,
  origin: null,
  inProgress: false,
  paymentOption: 'creditCard', // TODO Replace with PaymentMethod when the application is moved
  isUnpause: false,
  userShippingAddress: {},
  subscriptionProgress: null,
  subscriptionCase: Boolean(getCookieValue(constants.cookieNames.casesSubscription, true)),
  isFacebookMixLandingCampaign: Boolean(getCookieValue(constants.cookieNames.isFacebookMixLandingCampaign, true)),
  isSubscriptionFetching: false,
  instantShowDisplayProcessBanner: false,
  canBuyInOneClick: false,
}

export const update = (state, payload) => (
  { ...state, ...payload }
)

export const updatePaymentOption = (state, payload) => (
  object.set(state, 'paymentOption', String(payload))
)

export const setUnpause = (state, payload) => (
  { ...state, isUnpause: payload }
)

export const setIsFacebookMixLandingCampaign = (state, payload) => (
  { ...state, isFacebookMixLandingCampaign: payload }
)

export const setUserShippingAddress = (state, payload) => (
  { ...state, userShippingAddress: payload }
)

export const setSubscriptionCaseStatus = (state, payload) => (
  { ...state, subscriptionCase: payload }
)

export const setCanBuyInOneClickStatus = (state, payload) =>
  ({ ...state, canBuyInOneClick: payload })
